export const headings = [
  "Id.",
  "Name",
  "Type",
  "$Due",
  "Location",
  "Created On",
  "Reservations",
  "Seating",
  "Owner",
  "Contact",
  "Status",
];
